// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'
import React from 'react'
import { Mutation, Query } from 'react-apollo'
import Loader from '../../../../../common/loader/Loader'
import NewSelect from '../../../../../common/select/NewSelect'
import { i18n } from '../../../../index'
import { fetchFileLinks, updateFileLink } from '../../queries'
import { fetchLinkTags } from '../LinkTags/queries'
import css from './UpdateDialog.css'

const updateCache = (cache, { data: { updateFileLink } }) => {
  const { fileLinks } = cache.readQuery({
    query: fetchFileLinks,
  })
  cache.writeQuery({
    query: fetchFileLinks,
    data: {
      fileLinks: [
        ...fileLinks.map((fileLink) => {
          return fileLink.id === updateFileLink.id ? updateFileLink : fileLink
        }),
      ],
    },
  })
}

class UpdateDialog extends React.Component {
  constructor() {
    super()
    this.state = {
      id: '',
      fileName: '',
      href: '',
      selectedLinkTag: '',
    }
  }

  componentDidUpdate(prevProps) {
    const { data } = this.props
    const selectedLinkTag = (data.linkTags ?? [])[0]?.id

    if (data !== prevProps.data) {
      this.setState({ ...data, selectedLinkTag })
    }
  }

  onCancel = () => {
    this.setState({
      fileName: '',
      href: '',
      selectedLinkTag: '',
    })
    this.props.close()
  }
  onSubmit = (e, onMutate) => {
    e.preventDefault()
    const { id, fileName, href, selectedLinkTag } = this.state
    onMutate({
      variables: {
        id,
        fileName,
        href,
        linkTagId: selectedLinkTag,
      },
      update: updateCache,
    })
    this.props.close()
  }

  onLinkTagSelected = (value: string) => {
    this.setState({
      ...this.state,
      selectedLinkTag: value === '' ? null : value,
    })
  }

  render() {
    const { isOpen } = this.props
    const { fileName, href, selectedLinkTag } = this.state
    return (
      <Dialog open={isOpen} onBackdropClick={this.onCancel} disableEnforceFocus>
        <DialogTitle>{i18n.t('admin.guidelinesAndLinks.updateDialogTitle')}</DialogTitle>

        <DialogContent>
          <Query query={fetchLinkTags}>
            {({ data, loading }) => (
              <Loader {...{ loading }}>
                <Mutation mutation={updateFileLink}>
                  {(onMutate) => (
                    <form onSubmit={(e) => this.onSubmit(e, onMutate)}>
                      <TextField
                        autoFocus
                        required
                        fullWidth
                        label={i18n.t('admin.guidelinesAndLinks.fileName')}
                        placeholder={i18n.t('admin.guidelinesAndLinks.fileNamePlaceholder')}
                        className={css.input}
                        value={fileName}
                        onChange={(e) =>
                          this.setState({
                            fileName: e.target.value,
                          })
                        }
                      />

                      <TextField
                        required
                        fullWidth
                        label={i18n.t('admin.guidelinesAndLinks.link')}
                        placeholder={i18n.t('admin.guidelinesAndLinks.linkPlaceholder')}
                        className={css.input}
                        value={href}
                        onChange={(e) =>
                          this.setState({
                            href: e.target.value,
                          })
                        }
                      />

                      <NewSelect
                        options={data?.linkTags?.map((linkTag) => ({ label: linkTag.name, value: linkTag.id })) ?? []}
                        value={selectedLinkTag ?? ''}
                        onChange={this.onLinkTagSelected}
                        label={i18n.t('admin.guidelinesAndLinks.selectTag')}
                      />

                      <DialogActions>
                        <Button type='button' onClick={this.onCancel}>
                          {i18n.t('buttons.cancel')}
                        </Button>
                        <Button type={'submit'} color={'primary'}>
                          {i18n.t('buttons.save')}
                        </Button>
                      </DialogActions>
                    </form>
                  )}
                </Mutation>
              </Loader>
            )}
          </Query>
        </DialogContent>
      </Dialog>
    )
  }
}

export default UpdateDialog
